import { render } from "./informacoes_gerais.vue?vue&type=template&id=eed5d74a&scoped=true"
import script from "./informacoes_gerais.vue?vue&type=script&scoped=true&lang=js"
export * from "./informacoes_gerais.vue?vue&type=script&scoped=true&lang=js"

import "./informacoes_gerais.vue?vue&type=style&index=0&id=eed5d74a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed5d74a"]])

export default __exports__